import React from "react";
import ChartLoader from "../../Common/ChartLoader";

const ChartSkeleton = () => {
  return (
    <div
      className="border-bottom rounded-3 border-2 shadow"
      style={{ height: "50%" }}
    >
      <div
        className="p-1 border-bottom"
        style={{ height: "10%", overflow: "auto" }}
      >
        <div
          className="shimmer"
          style={{ height: "1.5rem", width: "60%" }}
        ></div>
      </div>

      <div
        style={{ height: "90%", overflow: "auto", position: "relative" }}
        className="p-1   border-bottom rounded-2 "
      >
        <div
          className="shimmer"
          style={{ height: "100%", width: "100%" }}
        ></div>
        <ChartLoader />
      </div>
    </div>
  );
};

export default ChartSkeleton;
